import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '1rem',
  },

  headerBack: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: 0,

    '& h1': {
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: '#000000',
    },
  },

  filter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
  },

  columnn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0rem',
    marginRight: '2rem',

    '& h3': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: '#8B8D97',
    },
  },

  boxContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',

    '& p': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: '#000000',
      margin: 0,
      paddinng: 0,
    },
  },

  clearButton: {
    padding: '0.35rem 1rem',
    height: '2.25rem',
  },

  filterInput: {
    height: '2.25rem !important',
    width: '280px !important',

    '& .MuiOutlinedInput-root': {
      height: '2.25rem !important',
    },
  },
}))

export { useStyles }
